import { render, staticRenderFns } from "./buddhism-form.vue?vue&type=template&id=1ba6c7ee&scoped=true"
import script from "./buddhism-form.vue?vue&type=script&lang=js"
export * from "./buddhism-form.vue?vue&type=script&lang=js"
import style0 from "./buddhism-form.vue?vue&type=style&index=0&id=1ba6c7ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6c7ee",
  null
  
)

export default component.exports